import { AutomaticPayloadOrder, LastOrderResponse } from 'contracts/Orders';
import { useAuth } from 'hooks/auth';
import { applyQueryString, api } from 'services';

export function useOrder() {
  const { token } = useAuth();

  const getOrderPrint = async (id: string | number): Promise<any> => {
    const { data } = await api.get(`/orders/${id}/print`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    let totalVolume = 0;
    for (const order of data) {
      totalVolume += order.orderItems.reduce(
        (acc: number, item: any) => acc + item.volume,
        0
      );
    }

    data[0].totalVolume = totalVolume;

    return data;
  };

  const getOrders = async (
    filters: any,
    orderTypeId?: string
  ): Promise<any> => {
    // let statusFilter = '';

    // if(filters.statusFilter.length > 0 && !filters.statusFilter.includes('todos')) {
    //   statusFilter = `?status=${filters.statusFilter.join('%2C')}`;
    // } else {
    //   statusFilter = `?status=${checkboxOptions.map((option) => option.id).join('%2C')}`
    // }

    const url = applyQueryString(`/orders`, {
      ...filters.formFilter,
      orderTypeId,
      status: filters.statusFilter.join(','),
    });

    const { data } = await api.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data;
  };

  const updateOrderStatus = async (
    ids: number[],
    status: string,
    cancelationReasonId?: string
  ): Promise<any> => {
    const data = await api.put(
      `/orders/update-status`,
      {
        ids: ids,
        status,
        cancelationReasonId: cancelationReasonId || null,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return data;
  };

  const createOrder = async (order: any): Promise<any> => {
    const data = await api.post(`/orders`, order, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data;
  };

  const updateOrderItems = async (items: any): Promise<any> => {
    const data = await api.put(`/orders/items`, items, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data;
  };

  const cancelOrderItems = async (items: any): Promise<any> => {
    const data = await api.put(`/orders/cancelItems`, items, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data;
  };

  const getLastOrderByDriver = async (
    driverId: string | number
  ): Promise<AutomaticPayloadOrder | null> => {
    if (!driverId) return null;

    const { data } = await api.get<LastOrderResponse | null>(
      `/last-orders/${driverId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!data) return null;

    const automaticPayloadOrder: AutomaticPayloadOrder = {
      ...data,
      warehouse: {
        name: data.warehouse?.tradeName,
        value: data.warehouse?.id.toString(),
      },
      cargoType: {
        name: data.cargoType?.name,
        value: data.cargoType?.id.toString(),
      },
      carrier: {
        name: data.carrier?.tradeName,
        value: data.carrier?.id.toString(),
      },
      operationType: {
        name: data.operationType?.name,
        value: data.operationType?.id.toString(),
      },
      orderType: {
        name: data.orderType?.name,
        value: data.orderType?.id.toString(),
      },
      vehicleType: {
        name: data.vehicleType?.name,
        value: data.vehicleType?.id.toString(),
      },
      relatedCompanies:
        data.relatedCompanies?.map((company) => {
          let displayName = company.tradeName;

          if (company.addressComplement) {
            displayName += ` - ${company.addressComplement}`;
          }
          if (company.ie) {
            displayName += ` - IE: ${company.ie}`;
          }

          return {
            name: displayName,
            value: company.id.toString(),
          };
        }) || [],
    };

    return automaticPayloadOrder;
  };

  return {
    getOrderPrint,
    getOrders,
    updateOrderStatus,
    createOrder,
    updateOrderItems,
    cancelOrderItems,
    getLastOrderByDriver,
  };
}
